angular.module('bmsApp.ticket')
	.controller('RaiseTicketModalCtrl',
		function ($state,
				  $rootScope,
				  $timeout,
				  $modalInstance,
				  $scope,
				  Upload,
				  $q,
				  notify,
				  TicketTypesSvc,
				  TicketSvc) {


			var self = this;
			self.options = {};
			self.uploadedFiles = [];
			self.formvalidatorconfig = {};
			self.formValidator = {};
			self.drag = {
				isDragging: false
			};
			self.form = {
				note: {}
			};
			self.methods = {
				init: init,
				submit: submit,
				cancel: cancel,
				drag: drag,
				uploadFiles: uploadFiles
			}

			function init() {
				TicketTypesSvc.options().then(function(response) {
					self.options.types = response.data.type_options;
				});
			}

			function drag($isDragging, $class, $event) {
				$timeout(function() {
					self.isDragging = $isDragging;
				});
			}

			function uploadFiles(files) {
				self.uploadInProgress = true;
				var promises = [];
				if (files && files.length) {
					angular.forEach(files, function(file) {
						promises.push(Upload.upload({
							url: 'api/ticket/upload',
							data: {
								file: file
							}
						}));
					});

					$q.all(promises).then(function(responses) {
						angular.forEach(responses, function(response) {
							self.uploadedFiles.push(response.data.file);
						});
						$timeout(function() {
							self.isDragging = false;
							self.uploadInProgress = false;
						});
					}, function(errors) {
						$timeout(function() {
							self.isDragging = false;
							self.uploadInProgress = false;
						});

					});
				}
			}


			function cancel() {
				$modalInstance.dismiss('cancel');
			}

			function submit() {
				if (self.formValidator.valid()) {
					var params = {
						form: self.form,
						files: self.uploadedFiles,
					};
					TicketSvc.save(params).then(function(response) {
						notify({
							message: 'Ticked submitted. You can view your outstanding tickets from your dashboard'
						});
						$rootScope.$broadcast('onTickedAdded');
						$modalInstance.close();
					});

				}
			}


		});
